// @flow

import React, { useState } from 'react';
import { jobs as t } from 'helpers/translation';
import FilterItem from './FilterItem';

type Props = {
  search: any,
  filter: {
    limit: number | string,
    data: Array<any>,
    url_param: string,
    label: string,
    counts_param: string
  },
  counts: any,
  pushToSearch: Function
};

export default ({ search, filter: { limit, data, url_param, label, counts_param }, counts, pushToSearch }: Props) => {
  const [hideItems, setHideItems] = useState(!search[url_param]);

  const handleClick = () => {
    setHideItems(!hideItems);
  };

  const itemsWithCounts = data.filter(i => counts[counts_param] && +counts[counts_param][i.counts_by] > 0);

  return (
    <div className={`col filter filter_jobs${itemsWithCounts.length ? '' : ' hidden'}`}>
      <div className="filter__title">{label}</div>
      <div className="filter__items">
        {itemsWithCounts.map((item, index) => (
          <FilterItem
            search={search}
            key={item.id}
            index={index}
            item={item}
            url_param={url_param}
            count={counts[counts_param] ? counts[counts_param][item.counts_by] : 0}
            limit={limit}
            hideItems={hideItems}
            pushToSearch={pushToSearch}
          />
        ))}
      </div>
      {+limit < itemsWithCounts.length
        ? <button type="button" className="filter__more" onClick={() => handleClick()}>
          {
            hideItems
              ? `+ ${ t.expand.more }`
              : `- ${ t.expand.less }`
          }
        </button>
        : ''
      }
    </div>
  );
};
